<template>

  <v-data-table
    :headers="_headers"
    :items="_items"
    :item-class="itemClass"
    :server-items-length="_total"
    :footer-props="footer"
    :no-data-text="labels.nodata"
    :loading="loading"
    :options.sync="options"
    @click:row="$emit('click', $event)"
  >
    <template v-slot:item.type="{ item }">
      <responsive-icon v-if="item.failure" :label="$t('failure')" breakpoints="xs">
        <font-awesome-icon icon="exclamation-circle" size="lg" class="type-failure"></font-awesome-icon>
      </responsive-icon>

      <responsive-icon v-if="item.maintenance" :label="$t('maintenance')" breakpoints="xs">
        <font-awesome-icon icon="tasks" size="lg" class="type-maintenance"></font-awesome-icon>
      </responsive-icon>
    </template>

    <template v-slot:item.id="{ item }">
      #{{ item.id }}
    </template>

    <template v-slot:item.actionAt="{ item }">
      {{ item.actionAt | datetime }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="red" v-if="!item.closed && !item.isInProgress">{{ $t('issues.status.new') }}</v-chip>
      <v-chip outlined small color="primary" v-if="!item.closed && item.isInProgress">{{ $t('issues.status.in-progress') }}</v-chip>
      <v-chip outlined small color="success" v-if="item.closed">{{ $t('issues.status.closed') }}</v-chip>
    </template>

    <template v-slot:item.assets="{ item }">
      {{ item.asset.fullPath }}
    </template>

    <template v-slot:item.interventions="{ item }">
      {{ interventions(item).length }}
    </template>

    <template v-slot:item.description="{ item }">
      {{ item.xDisplayName }}
    </template>

    <template v-slot:item.actions="{ item }">
      <responsive-icon :label="$t('issues.edit')" breakpoints="xs">
        <font-awesome-icon icon="pen" size="lg"></font-awesome-icon>
      </responsive-icon>
    </template>
  </v-data-table>

</template>

<script>

  import dataTable from '../../helpers/data-table.es6'
  import ResponsiveIcon from '../../shared/components/responsive-icon'

  export default {
    name: 'issues-table',
    mixins: [ dataTable ],

    props: [ 'hidden' ],

    data () {
      return {
        sortRules: {
          assets: 'assets.name',
          status: 'closed'
        },
        headers: [
          { text: this.$t('type'), value: 'type', sortable: false },
          { text: this.$t('number'), value: 'id' },
          { text: this.$t('date'), value: 'actionAt' },
          { text: this.$t('issues.status'), value: 'status', sortable: false },
          { text: this.$t('entityNames.assets'), value: 'assets' },
          { text: this.$t('description'), value: 'description', sortable: false },
          { text: this.$tc('interventions.entity-name', 2), value: 'interventions', sortable: false },
          { text: this.$t('shared.actions'), value: 'actions', sortable: false },
        ]
      }
    },

    computed: {
      _headers () {
        return this.headers.filter(column => ![].concat(this.hidden).includes(column.value))
      }
    },

    methods: {
      itemClass (issue) {
        return {
          expired: !issue.closed && this.expired(issue)
        }
      },

      expired (issue) {
        return new Date(issue.actionAt) < new Date()
      },

      interventions (issue) {
        return issue.interventions.filter(x => !x.archivedAt)
      }
    },

    components: {
      ResponsiveIcon
    },
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  ::v-deep {
    tbody tr {
      &.expired td {
        background-color: lighten($color-warn, 40%);
      }

      &.expired:hover td {
        background-color: lighten($color-warn, 37%);
      }
    }
  }

  .type {
    &-failure {
      color: $color-warn;
    }

    &-maintenance {
      color: $color-primary;
    }

    &-closed {
      color: $color-success;
    }
  }

</style>
